export const organizationConstants = {
    GETORGANIZATION_REQUEST: 'ORGANIZATION_REQUEST',
    GETORGANIZATION_SUCCESS: 'ORGANIZATION_SUCCESS',
    GETORGANIZATION_FAILURE: 'ORGANIZATION_FAILURE',
    TOGGLE_ADD_CLIENT_MODAL:'TOGGLE_ADD_CLIENT_MODAL',
    ADD_CLIENT_REQUEST:'ADD_CLIENT_REQUEST',
    ADD_CLIENT_SUCCESS:'ADD_CLIENT_SUCCESS',
    ADD_CLIENT_FAILURE:'ADD_CLIENT_FAILURE'
};
